import type { ReactNode } from 'react'
import type { TeamScopeKey } from '../../types/database'
import { useAuth } from '../../contexts/AuthContext'
import NotAccessibleCard from './NotAccessibleCard'

type Props = { scope: TeamScopeKey; children: ReactNode }

// ScopeGate: transparent for podcasters/admins + loading state; renders
// NotAccessibleCard when a team_member lacks the scope. Loading fall-through
// lets the page's own loading UI drive the display (prevents flash of card).
export default function ScopeGate({ scope, children }: Props) {
  const { accountType, permissions, loading } = useAuth()
  if (loading) return <>{children}</>
  if (accountType !== 'team_member') return <>{children}</>
  if (permissions?.[scope] === true) return <>{children}</>
  return <NotAccessibleCard scope={scope} />
}
